import { CANCELLED } from 'constants/orderStatuses';

const getOrderStatus = order => {
  if (order.cancelled) return CANCELLED;
  return order.status;
};

export default getOrderStatus;
